<template>
  <div class="app-category-wrapper">

    <div class="custom-wrapper op-wrapper"
      v-if="hasRes('store_app_category_add')" >
      <el-button
        type="danger"
        size="medium">添加应用分类</el-button>
    </div>

    <app-category-filter
      v-if="hasRes('store_app_category_index')"
      @filter="updateTableData" />

    <custom-table
      :data="appCategoryList"
      v-if="hasRes('store_app_category_index')"
      @data-change="updateTableData">

      <el-table-column
        prop="app_category_id"
        label="应用分类 ID"
        align="center"
        header-align="center">
      </el-table-column>

      <el-table-column
        prop="app_category_name_i18n"
        label="分类名称"
        align="center"
        header-align="center">
        <template slot-scope="scope">
          {{ scope.row.app_category_name_i18n[0].name }}
        </template>
      </el-table-column>

      <el-table-column
        prop="father_category_id"
        label="父分类 ID"
        align="center"
        header-align="center">
      </el-table-column>

      <el-table-column
        prop="level"
        label="分类层数"
        align="center"
        header-align="center">
      </el-table-column>
    </custom-table>

    <custom-paginate
      :count="appCategoryCount"
      v-if="hasRes('store_app_category_index')"
      @page-change="updateTableData" />

  </div>
</template>

<script>
import CustomTable from '@/components/CustomTable'
import CustomPaginate from '@/components/CustomPaginate'
import AppCategoryFilter from './components/AppCategoryFilter'

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { SET_LOADING } from '@/store/modules/table'

export default {
  name: 'AppCategory',
  components: {
    CustomTable,
    CustomPaginate,
    AppCategoryFilter
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState('table', [
      'page',
      'pageSize',
      'filters'
    ]),
    ...mapState('store', [
      'appCategoryList',
      'appCategoryCount'
    ]),
    ...mapGetters('opUser', [
      'hasResCate',
      'hasRes'
    ])
  },
  methods: {
    ...mapMutations('table', [
      SET_LOADING
    ]),
    ...mapActions('store', [
      'getAppCategories'
    ]),

    async updateTableData () {
      if (!this.hasRes('store_app_category_index')) return

      this.setLoading(true)

      try {
        await this.getAppCategories({
          page: this.page,
          pageSize: this.paegSize,
          condition: this.filters
        })
      } catch (err) {
        console.log(err)
        this.$message({
          tpye: 'error',
          message: '获取应用分类列表失败'
        })
      }

      this.setLoading(false)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/sass/base.scss';
</style>



// WEBPACK FOOTER //
// src/pages/op/store/AppCategory.vue